var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['section-group-datas', { 'side-by-sides': _vm.sideBySide }]},[_c('div',{class:['section-group-title2', { sm: _vm.sm }]},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(!_vm.editMode)?_c('div',{class:[{ disabled: _vm.disabled }],style:(`text-align: ${_vm.sideBySide ? 'right' : 'left'}`)},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }